export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body, $social, $logo;

	function init() {
		($menu = $('.site-header')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');
		$logo = $('.logo');

		events();
	}

	function events() {

		$menu.find('.nav-items > li').each(function(){
			var linkTitle = $(this).children('a').text();
			$(this).find('span').append('<div class="ticker" aria-hidden="true"></div>');
			// console.log('test', $(this).clone().children('a').text() );
			for (var i = 0; i < 5; i++) {
				$('.ticker').append( $(this).clone().children('a').text() + ' ' );
			}
			// $(this).find('span').append('<div class="ticker" aria-hidden="true">' + linkTitle + ' ' + linkTitle + ' ' + linkTitle + '</div>');
		});

		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}
		});

		if( !$("#pxMainContent > *:first").hasClass('pxblock--banner') ) {
			$logo.addClass('logo--dark');
		}
	}

	return {
		init: init,
	};
})();
